// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const AdminMenu = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 13c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6zM1 23c0-5 5-10 11-10M18.5 14l1.0774 1.54 1.8151-.4872-.1645 1.8722 1.7036.7936-1.3295 1.3284.795 1.703-1.8723.163-.4857 1.8156L18.5 21.65l-1.5391 1.0786-.4857-1.8156-1.8723-.163.795-1.703-1.3295-1.3284 1.7036-.7936-.1645-1.8722 1.8151.4872L18.5 14z" /></React.Fragment>, },
  'default'
);
